module.exports = __webpack_public_path__ + "media/images/lp/1/voice1-open-df8aee7e652dfc3eee8a9378ea44e5bc.png";